import React, { useMemo } from 'react';
import MirsTable from 'components/general/table/Table.js';
import { findArray, filterArray, isParalympic, CompetitionFromStore } from 'helpers/utils';
import { ColumnNameH2H } from "components/common/TableColumns"
import { NocMemo as Noc } from 'components/presentation/Noc';
import Competitor from 'components/presentation/Competitor';
import { useViewport } from 'components/general/useViewPort'
import Label from "components/general/Label";
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

function GblPlayerStats({ data, team }) {
  const { mirs_rsc } = useUrlFriendlyToParameters()
  const competition = CompetitionFromStore();
  const bIsParalympic = isParalympic(competition);
  let athletes = findArray(data?.results?.items, { startSortOrder: [team] })?.teamAthletes;
  const teamTotal = findArray(data?.results?.items, { startSortOrder: [team] })?.statsItems;
  let statsArray = [];
  statsArray = ['SUB', 'SUB_MED', 'MINS', 'SHOT', 'PTY', 'TOT'];

  athletes?.forEach(item => item.block = item?.eventUnitEntries?.find(eu => eu?.eue_code === 'STARTER') ? 1 : 3)

  function getItems(type = 'Total') {
    let out = statsArray.map((item) => {
      let val;
      let stat;
      if (type === 'Total') {
        stat = item === 'MINS' ? '' : item
      } else {
        stat = item === 'GF' ? 'GF_OG' : ''
      }
      val = findArray(teamTotal, { code: [stat] })
      return {
        code: item, value: val?.value, attempt: val?.attempt, extend: val?.extendedStatsItems?.find(item => item?.code === "PTY")?.value
      }
    })
    return (out)
  }


  let extra3 = {
    athlete: { code: '1000022' },
    bib: 100001,
    block: 5,
    title: <span className='fw-bold'><Label data='HeaderTotals' /></span>,
    statsItems:
      getItems(),
  }

  //Before to inser check if exist yet

  athletes = athletes?.filter(item => item.code !== 100000 && item.code !== 100001)

  Array.isArray(athletes) && athletes.push(extra3)

  let competitorNoc = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.organisation?.code;
  let competitorName = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.name;
  let competitorCode = findArray(data?.results?.items, { startSortOrder: [team] })?.participant?.code;
  let participant = findArray(data?.results?.items, { startSortOrder: [team] })?.participant;
  const stats = [
    { code: 'LEADING' }
  ]

  const tableColumns =
    [
      {
        id: 'PlayerStatsBlock',
        disableSort: false,
        accessor: 'block'
      },
      {
        id: 'PlayerStatsBib',
        disableSort: false,
        className: 'text-end',
        headerClassName: 'text-end w-5 text-nowrap',
        Header: <Label data={'HeaderNumber'} />,
        remove: false,
        accessor: 'startSortOrder',
        Cell: (props) => {
          return (props.cell.row.original.bib > 99999) ? '' : props.cell.row.original.bib
        }
      },
      ColumnNameH2H({ showDisciplineClass: true }),
      {
        id: 'PlayerStatsSub',
        Header: <Label data={'HeaderSub'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SUB'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsMSub',
        Header: <Label data={'HeaderMSub'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SUB_MED'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsMIN',
        Header: <Label data={'Statistics_MIN'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        accessor: (props) => (
          findArray(props.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsTG',
        Header: <Label data={'Statistics_TG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsTP',
        Header: <Label data={'Statistics_TP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''

          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsTT',
        Header: <Label data={'Statistics_TT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).attempt}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsPTG',
        Header: <Label data={'Statistics_PTG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsPTP',
        Header: <Label data={'Statistics_PTP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsPTT',
        Header: <Label data={'Statistics_PTT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTG',
        Header: <Label data={'Statistics_TOTG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] }).value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTP',
        Header: <Label data={'Statistics_TOTP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTT',
        Header: <Label data={'Statistics_TOTT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] }).attempt}
            </span>
          )
        }
      },
    ]

  const tableColumnsSM =
    [
      {
        id: 'PlayerStatsBlock',
        disableSort: false,
        accessor: 'block'
      },
      {
        id: 'PlayerStatsBib',
        disableSort: false,
        className: 'text-end',
        headerClassName: 'text-end w-5 text-nowrap',
        Header: <Label data={'HeaderNumber'} />,
        remove: false,
        accessor: 'startSortOrder',
        Cell: (props) => {
          return (props.cell.row.original.bib > 99999) ? '' : props.cell.row.original.bib
        }
      },
      ColumnNameH2H({ showDisciplineClass: true, hideNoc: true }),

      {
        id: 'PlayerStatsSub',
        Header: <Label data={'HeaderSub'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 1,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SUB'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsMSub',
        Header: <Label data={'HeaderMSub'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 2,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SUB_MED'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsMIN',
        Header: <Label data={'Statistics_MIN'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 3,
        accessor: (props) => (
          findArray(props.statsItems, { code: ['MINS'] }).value
        )
      },
      {
        id: 'PlayerStatsTG',
        Header: <Label data={'Statistics_TG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 4,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsTP',
        Header: <Label data={'Statistics_TP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 5,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''

          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsTT',
        Header: <Label data={'Statistics_TT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 6,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['SHOT'] }).attempt}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsPTG',
        Header: <Label data={'Statistics_PTG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 7,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).value}
            </span>
          )
        }
      },

      {
        id: 'PlayerStatsPTP',
        Header: <Label data={'Statistics_PTP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 8,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsPTT',
        Header: <Label data={'Statistics_PTT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 9,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['PTY'] }).attempt}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTG',
        Header: <Label data={'Statistics_TOTG'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 10,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] }).value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTP',
        Header: <Label data={'Statistics_TOTP'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 11,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] })?.extendedStatsItems?.find(item => item?.code === "PTY")?.value}
            </span>
          )
        }
      },
      {
        id: 'PlayerStatsTOTT',
        Header: <Label data={'Statistics_TOTT'} />,
        headerClassName: "text-end",
        className: 'text-end w-5',
        isVisible: false,
        columnIndex: 12,
        Cell: (props) => {
          let isBold = props.cell.row.original.block === 4 || props.cell.row.original.block === 5 ? 'fw-bold' : ''
          return (
            <span className={isBold}>
              {findArray(props.cell.row.original.statsItems, { code: ['TOT'] }).attempt}
            </span>
          )
        }
      },
    ]


  let _playersCurrents = filterArray(data?.results?.extendedInfos, { ei_code: ['CURRENT'] });
  let _caption = <CaptionTeam competitorNoc={competitorNoc} participant={participant} />
  const playersCurrents = _playersCurrents && _playersCurrents.map((player) =>
    player.ei_value
  );
  const { breakPoint } = useViewport();

  let columns = useMemo(() => (breakPoint === "sm" || breakPoint === "xs") ? tableColumnsSM : tableColumns, [breakPoint])
  let arrHidenColumns = ['PlayerStatsBlock']

  if (!bIsParalympic) {
    arrHidenColumns.push('PlayerStats2PTY')
  }
  return (
    <>

      {athletes && <MirsTable
        id={`mirs-table-player-statistics-${team + '-' + mirs_rsc}-${competitorCode}`}
        caption={_caption}
        data={athletes}
        columns={columns}
        keyRow={"athlete-code"}
        hiddenColumns={arrHidenColumns}
        initialSortBy={[{ id: 'PlayerStatsBlock', desc: false }, { id: 'PlayerStatsBib', desc: false }]}
        getRowProps={row => ({
          className: playersCurrents.includes(row?.original?.athlete.code) ? 'currentIndicator' : '',
        })}
        colsExtendedVisible={'3,3,3,3'}
        showNavExtendedData={(breakPoint === "sm" || breakPoint === "xs") ? true : false}
      />}
    </>
  );
}

export default GblPlayerStats;

function CaptionTeam({ competitorNoc, participant }) {
  return (
    <div className='d-flex align-items-center'>
      <div className='d-none d-md-block me-1'>
        <Noc {...participant?.organisation} />
      </div>
      <strong>
        <Competitor hidePicture={true} {...participant} />
      </strong>
    </div>
  )
}

function PlayerStatsType2({ value, attempt }) {
  if (value !== undefined) {
    return (
      <>
        {value}/{attempt}
      </>
    )
  }
}

function playerStats2PTY() {

  return {
    id: 'PlayerStats2PTY',
    Header: <Label data={'Statistics_2PTY'} />,
    headerClassName: "text-end",
    className: 'text-end w-5',
    isVisible: false,
    columnIndex: 8,
    accessor: (props) => {
      let value = findArray(props.statsItems, { code: ['2PTY'] }).value;
      let attempt = findArray(props.statsItems, { code: ['2PTY'] }).attempt;
      let isBold = props.block === 4 || props.block === 5 ? 'fw-bold' : ''
      return (
        <span className={isBold}><PlayerStatsType2 value={value} attempt={attempt} /></span>
      )
    }
  }



}